// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionReason-cls1_WVd","cls2":"SuggestionReason-cls2_FPR SuggestionReason-cls1_WVd"};